import React from 'react';

const AuthSuccessMessage = ({ action, fundingId, fundingName }) => {
  const getSuccessMessage = () => {
    switch (action) {
      case 'view funding details':
        return `You can now view the full details for "${fundingName || 'this funding opportunity'}".`;
      case 'apply for funding':
        return `You can now apply for "${fundingName || 'this funding opportunity'}".`;
      case 'save funding opportunities':
        return 'You can now save funding opportunities to your profile.';
      default:
        return 'Authentication successful! You can now access all features.';
    }
  };

  if (!action) return null;

  return (
    <div className="bg-green-50 border border-green-200 rounded-md p-4 mb-4">
      <div className="flex">
        <div className="flex-shrink-0">
          <svg className="h-5 w-5 text-green-400" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
          </svg>
        </div>
        <div className="ml-3">
          <p className="text-sm font-medium text-green-800">
            Welcome! {getSuccessMessage()}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AuthSuccessMessage;
